<template>
  <div class="d-flex justify-content-center my-2">
    <b-card title=""
        bg-variant="light"
        border-variant="success"
        style="max-width: 500px;"
    >
      <!-- Logo Cabecera -->
      <div class="text-center my-2">
      </div>
          <b-avatar size="4em" variant="success" icon="globe"></b-avatar>

      <!-- <b-form @submit.prevent="login">    -->
      <b-form>
      <!-- usuario -->
        <b-form-group class="pt-2"
            label="Correo Electrónico / Teléfono" label-for="user"
            v-bind="attr_login">
            <b-input-group class="my-2">
              <!-- <b-input-group-prepend is-text>
                <b-icon-person-fill/>
              </b-input-group-prepend>  -->
              <b-form-input type="text" id="user" ref="user"
                v-model="user.user" trim
                v-bind="attr_login"
              ></b-form-input>
              <b-input-group-prepend is-text v-show="user.logU">
                <b-icon-x-circle-fill
                  v-b-tooltip="ttip('Cancelar<br>Cambio de Usuario')"
                  @click="user.logU=false"/>
              </b-input-group-prepend>
            </b-input-group>
        </b-form-group>

      <!-- password - contraseña -->
        <b-form-group
          v-show="user.logU"
          label="Contraseña / Password" label-for="pass">
          <b-form-input
            id="pass" ref="pass" v-model="user.pass" type="password"

          ></b-form-input>
        </b-form-group>
        <!-- <a @keyup.enter.prevent="check">  -->

        <!-- Botones -->
        <b-button block pill variant="success" type="submit"
          v-b-tooltip.hover title="Conectar"
          @click.prevent="check"
        > {{ btn_login }}
        </b-button>

        <p class="mt-3">
            <!-- <router-link to="/login" class="pr-3" ref="olvida">¿Olvidó su contraseña?</router-link>
            <router-link to="/registro" class="pr-3" ref="registro">Quiero Registrarme</router-link> -->
            <b-button variant="outline-secondary" ref="olvido" class="pr-1 mx-2" size="sm"
              @click="olvidar"> ¿ Olvido su Contraseña ? </b-button>
              <!-- <b-button variant="outline-secondary" ref="registro" class="mx-3" size="sm" to="/registro" -->
              <b-button variant="outline-secondary" ref="registro" class="mx-2" size="sm" @click="registro"
                v-b-tooltip="ttip('Enviar Formulario de <b>Registro</b>')"
                > Quiero REGISTRARME
              </b-button>
        </p>

      </b-form>
    </b-card>
  </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'Login',
  data() {
    return {
      user: { user:'', pass:'', error: '', logU: false, logP: false, sid: '' },
      error: { error: false, msg: '', title:'' },

    };
  },
   created() {
    if (this.logueado) {
      if (this.$route.name=='login')
        this.$router.push('/');
      else
        this.$bvModal.hide("modal_login");

    }
  },
  computed: {
    ...mapState(['auth','errores']),

    logueado() {
      return this.auth.logueado;
    },
    // atributos usuario / acceso
    attr_login() {
      if (this.user.logU) return {state: true, disabled: true, "valid-feedback": "USUARIO REGISTRADO" };
      if (this.user.error) return {state: false, disabled: false, "invalid-feedback": this.user.error };
      return { disabled: false};
    },
    // texto boton
    btn_login() {
      return (!this.user.logU ? "CONTINUAR" : "CONECTARSE");
    }
  },
  methods: {
    ...mapMutations(['loading','alerta','modal']),
    ...mapActions(['exec']),

    registro() {
            console.log(this.$route.name,this.$parent);

            if (this.$route.name!='login')  { //si modal
                this.$bvModal.hide("modal_login");
                this.$bvModal.show("modal_registro");
            } else
                this.$router.push('/login');
    },

    ttip(txt) {
      return {
        title: txt,
        placement: "topright",
        html: true,
        variant: "secondary",
        customClass: "tooltip1",

      }
    },
    // check -> login (async) -> login_back

    check() {
      let u=this.user.user;
      let p=this.user.pass;
      let t=this.auth.token;
      console.log("**check",this.user.logU,u,p);

      if (u==='') { this.user.error="Debes Introducir un Usuario"; return; }
      if (this.user.logU && p==='') { this.user.error="Debes Introducir una Contraseña"; return; }

      let args=(!this.user.logU ? {user: u} : {token: t, pass:p});
      this.login(args);
    },

    async login(args) {
      //this.loading();
      let r=await this.exec({api:'login', arg:args});
      this.login_back(r);
    },

    login_back(r) {
      this.user.error="";
      //////////////////////////////////////////////si error
      if (r.error) {
          if (!this.user.logU) {
            //this.user.logU=false;
            this.user.error=r.datos; //'Debe Introducir un Usuario Válido';
            this.$refs.user.focus();
          } else {
            this.user.error="Contraseña / Password Incorrecta";
            this.modal({tit:"Login / Acceso", msg: this.user.error});
            this.$refs.pass.focus();
          }
          return;
      }
      ////////////////////////////////////////////si valido
      //this.$store.commit('login_back',r);

      if (!this.user.logU) {
          this.user.logU=true;
          this.user.pass='';
          this.auth.token=r.datos.token;
      } else {
          this.$store.commit('login_back',r);

          //if (this.$route.name=='login') this.$router.push('/hoteles'); else
          this.$bvModal.hide("modal_login");
      }

      console.log("*login.login_back",this.auth);
    },
    olvidar() {
      alert('Olvidar Contraseña');
      //user.logU=!user.logU

    },

  }
}

</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.tooltip1 {
  font-family: Georgia;
  font-size: 20px;
}

.tooltip-inner {
  background-color: #44f;
}